export function productType(value) {
    let productType = {
        1: "45454"
    }
    return productType[+value]
}